import { render, staticRenderFns } from "./moneys.vue?vue&type=template&id=db84033a&"
import script from "./moneys.vue?vue&type=script&lang=js&"
export * from "./moneys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db84033a')) {
      api.createRecord('db84033a', component.options)
    } else {
      api.reload('db84033a', component.options)
    }
    module.hot.accept("./moneys.vue?vue&type=template&id=db84033a&", function () {
      api.rerender('db84033a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/moneys.vue"
export default component.exports